import { useState, useEffect } from 'react';
import { getCookieConsent, setCookieConsent } from '../utils/cookieConsent';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Afficher la bannière seulement si l'utilisateur n'a pas encore choisi
    const consent = getCookieConsent();
    if (consent === null) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent('accepted');
    setIsVisible(false);
    // Recharger la page pour initialiser GA
    window.location.reload();
  };

  const handleDecline = () => {
    setCookieConsent('declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Variante mobile : bandeau fin en bas de page */}
      <div className="block sm:hidden fixed inset-x-0 bottom-0 z-50 bg-white border-t border-gray-200 shadow-lg px-4 py-3 flex items-center justify-between gap-3 animate-fadeIn">
        <p className="text-xs text-neutral-body font-nunito flex-1 min-w-0 truncate">
          Ce site utilise des cookies pour améliorer votre expérience.{' '}
          <a href="/privacy-policy" className="underline text-brand">En savoir plus</a>
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={handleDecline}
            className="text-xs px-3 py-1.5 border border-gray-300 rounded-full text-neutral-body font-nunito hover:bg-gray-50 transition-colors"
          >
            Refuser
          </button>
          <button
            onClick={handleAccept}
            className="text-xs px-3 py-1.5 bg-brand text-white rounded-full font-nunito hover:bg-brand-dark transition-colors"
          >
            Accepter
          </button>
        </div>
      </div>

      {/* Variante desktop : carte compacte centrée */}
      <div className="hidden sm:flex fixed inset-x-0 bottom-0 z-50 justify-center px-4 pb-4 sm:pb-6 animate-fadeIn pointer-events-none">
        <div className="pointer-events-auto bg-white border border-neutral-line/60 shadow-xl rounded-2xl max-w-2xl w-full p-6 sm:p-8 transform transition-all animate-slideUp">
          {/* Icône */}
          <div className="flex items-center justify-center w-16 h-16 bg-brand-50 rounded-full mx-auto mb-4">
            <svg className="w-8 h-8 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
            </svg>
          </div>

          {/* Titre */}
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-3">
            Cookies et confidentialité
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-center mb-6 leading-relaxed">
            Nous utilisons uniquement <strong>Google Analytics</strong> pour mesurer la fréquentation du site. Les données collectées ne sont jamais partagées avec des tiers.
          </p>

          {/* Boutons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleAccept}
              className="flex-1 bg-[#9C4B24] hover:bg-[#7d3c1d] text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              Accepter
            </button>
            <button
              onClick={handleDecline}
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-lg transition-colors duration-200 border-2 border-gray-300"
            >
              Refuser
            </button>
          </div>

          {/* Lien politique */}
          <p className="text-center mt-4 text-sm text-gray-500">
            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-brand-600 transition-colors">
              En savoir plus sur notre politique de confidentialité
            </a>
          </p>
        </div>
      </div>
    </>
  );
};
